const siteHeader = document.querySelector('.siteHeader');
const navTrigger = document.querySelector('.navTrigger');
const nav = document.querySelector('.nav');
let position;

if (siteHeader) {

	function headerScroll() {
		if (window.pageYOffset >= 200) {
			siteHeader.classList.add('is-scrolling');
		} else {
			siteHeader.classList.remove('is-scrolling');
		}
	}

	window.addEventListener('load', headerScroll);
	window.addEventListener('scroll', headerScroll);
}

if (navTrigger) {

	navTrigger.addEventListener('click', () => {
		if (!document.body.classList.contains('no-scroll')) {
			position = window.pageYOffset;
		} else {
			setTimeout( () => {
				// remove scroll position jump fix and put back to correct position
				document.body.style.top = '';
				window.scrollTo(0, position);
			}, 10);
		}

		navTrigger.classList.toggle('is-active');
		nav.classList.toggle('is-active');
		siteHeader.classList.toggle('is-active');
		document.body.classList.toggle('no-scroll');
	})
}